const FE_API_Actions = Object.freeze({
  AdvanceSearch: "AdvanceSearchBtnClick",
  TableChange: "TableChangeEvents",
});
export default FE_API_Actions;
